import Loader from "components/shared/loader";
import { paths } from "helpers/paths";
import { useRouter } from "hooks/useRouter";
import React, { useState } from "react";
import { alert } from "services/alert";
import { acceptInvitation } from "sources/account";

export default function AcceptInvitation() {
    const router = useRouter();
    const [formData, setFormData] = useState({
        password: "",
        passwordConfirmation: "",
        key: router.query.key,
    });
    const [loading, setLoading] = useState(false);
    const submitForm = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        acceptInvitation(formData).then((res) => {
            setLoading(false);
            if (res) {
                alert({ type: "success", message: "Приглашение принято.", title: "Успешно!" });
                router.push(paths.login);
            }
        });
    };
    return (
        <div className="no-overflow h-100">
            <div className="identity-container">
                {loading && (
                    <div className="loader-snippet--disable-loader">
                        <Loader />
                    </div>
                )}
                <div className="identity-container__shadow" />
                <div className="identity-container__background" />
                <div className="identity-panel identity-panel--small">
                    <div className="identity-column">
                        <h1 className="identity-container__title" />
                        <div className="identity-column__title">Приглашение в систему</div>
                        <form className="identity-form" onSubmit={submitForm}>
                            <div className="identity-field">
                                <div className="col-12">
                                    <input
                                        required
                                        className="form-control"
                                        type="password"
                                        value={formData.password}
                                        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                        placeholder="Введите пароль"
                                    />
                                </div>
                            </div>
                            <div className="identity-field">
                                <div className="col-12">
                                    <input
                                        required
                                        className="form-control"
                                        type="password"
                                        value={formData.passwordConfirmation}
                                        onChange={(e) =>
                                            setFormData({ ...formData, passwordConfirmation: e.target.value })
                                        }
                                        placeholder="Повторите пароль"
                                    />
                                </div>
                            </div>
                            <div className="identity-field col-12">
                                <button
                                    className="identity-form__button identity-form__button--yellow identity-form__button--text-small"
                                    type="submit"
                                >
                                    Принять приглашение
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
